
import { Link, useLocation } from "react-router-dom";
import {
  Sidebar,
  SidebarContent,
  SidebarFooter,
  SidebarHeader,
  SidebarMenu,
  SidebarMenuButton,
  SidebarMenuItem,
} from "@/components/ui/sidebar";
import { BarChart3, BookOpen, CalendarIcon, LayoutDashboard, Mail, Upload, Users } from "lucide-react";
import { useAdminAuth } from "@/hooks/use-admin-auth";
import { Button } from "@/components/ui/button";

export default function AdminSidebar() {
  const location = useLocation();
  const { logout } = useAdminAuth();

  const menuItems = [
    {
      title: "Dashboard",
      icon: LayoutDashboard,
      path: "/admin",
    },
    {
      title: "Contact Messages",
      icon: Mail,
      path: "/admin/messages",
    },
    {
      title: "Events",
      icon: CalendarIcon,
      path: "/admin/events",
    },
    {
      title: "Programs",
      icon: BookOpen,
      path: "/admin/programs",
    },
    {
      title: "Volunteer Applications",
      icon: Users,
      path: "/admin/volunteers",
    },
    {
      title: "Analytics",
      icon: BarChart3,
      path: "/admin/analytics",
    },
    {
      title: "Donor Import",
      icon: Upload,
      path: "/admin/donor-import",
    },
  ];

  return (
    <Sidebar>
      <SidebarHeader>
        <div className="flex items-center h-14 px-4">
          <h2 className="font-bold text-lg">PHCSN Admin</h2>
        </div>
      </SidebarHeader>
      <SidebarContent>
        <SidebarMenu>
          {menuItems.map((item) => (
            <SidebarMenuItem key={item.path}>
              <SidebarMenuButton 
                asChild 
                isActive={location.pathname === item.path}
                tooltip={item.title}
              >
                <Link to={item.path}>
                  <item.icon />
                  <span>{item.title}</span>
                </Link>
              </SidebarMenuButton>
            </SidebarMenuItem>
          ))}
        </SidebarMenu>
      </SidebarContent>
      <SidebarFooter>
        <div className="p-4">
          <Button 
            variant="outline" 
            className="w-full"
            onClick={logout}
          >
            Logout
          </Button>
        </div>
      </SidebarFooter>
    </Sidebar>
  );
}
